import React from 'react'
import Button from '../Button'
import HeroImg from '../../assets/children/ireti.png'

const Hero = ({ id }) => {
  return (
    <section className='w-full hero flex flex-col lg:flex-row justify-between items-center p-4 lg:px-8 gap-5' id={id}>
      <div className='w-full lg:w-[60%]'>
        <h1 className='text-[32px] lg:text-[55px] text-[#576782] font-[900]'>
          Welcome to Iretiola Children’s Foundation
        </h1>
        <p className='text-[16px] lg:text-[20px] font-[400] leading-[24px] lg:leading-[32.4px] my-6'>
          Find out about our project and support the children in Nigeria. Together we make a difference. Together we create opportunities for children.
        </p>
       <a href='#donate'><Button style={'w-[150px] lg:w-[180px] h-[50px] lg:h-[60px] text-[16px] lg:text-[20px] font-[500] rounded-lg'} content={'Donate'} /></a> 
      </div>
      <div className='w-full lg:w-[45%] relative my-9 lg:ml-4'>
        <img src={HeroImg} alt='hero image' className='w-full lg:w-[450px] lg:h-[500px]' />
        <Button style={'w-[200px] lg:w-auto h-[40px] lg:h-[55px] text-[14px] lg:text-[20px] font-[400] absolute top-[10%] lg:py-[21px] left-[-10%] lg:left-[-30%] rounded-[20px]'} content={'Education Creates the future'} />
        <a href='#donate'><Button style={'w-[200px] lg:w-auto h-[40px] lg:h-[55px] text-[14px] lg:text-[20px] font-[400] absolute bottom-[10%] right-[-5%] lg:py-[21px] lg:px-[51px] rounded-[20px]'} content={'Your donation helps'} /></a> 
      </div>
    </section>
  )
}

export default Hero